import React, { useContext } from 'react';
import { Navigate, Route } from 'react-router-dom';
import { AuthContext } from 'context/authContext';

const PremiumPrivateRoute = ({ children, ...rest }) => {
  const { state } = useContext(AuthContext);
  const { userInfo } = state;

  return (
    userInfo?.email ? (
            children
            ) : (
                <Navigate to="/premium-login" replace />
            )
  );
};

export default PremiumPrivateRoute;
